import { Text } from 'components/Typography';
import React from 'react';
import style from './CategoryCard.scss';

type CategoryCardProps = {
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
  programsAmount?: number
};

export const CategoryCard: React.FC<CategoryCardProps> = ({ icon, label, onClick, programsAmount = 0 }) => {
  return (
    <div className={style.categoryCard} onClick={onClick}>
      <div className={style.iconContainer}>{icon}</div>
      <Text weight={400} className={style.label}>
        {`${label} (${programsAmount})`}
      </Text>
    </div>
  );
};
